module.exports = __webpack_public_path__ + "envato.jpg?c42066b3ecd8af382001744966be2eb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/envato.jpg
// module id = 54
// module chunks = 0